var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.hasChild)?_c('FirstLayerWithChild',{attrs:{"childs":_vm.childs,"title":_vm.title,"width":_vm.width,"indexParent":_vm.indexParent}}):_c('FirstLayerNoChild',{attrs:{"title":_vm.title,"isTheUrl":_vm.isUrl(_vm.isTrueUrl),"href":_vm.href,"width":_vm.width,"indexParent":_vm.indexParent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }